export default function swapListItem<T>(list: T[], oldItem: T, newItem: T) {
    return list.map((x) => (x === oldItem ? newItem : x))
}
